var map = {
	"./6523e4f711a532d90a4f3d97_isae3000-type1.png": "59c6",
	"./6523e4f711a532d90a4f3d97_isae3000-type1.webp": "7a66",
	"./6523e4f7485a7697ac114d41_gdpr.png": "952b",
	"./6523e4f7485a7697ac114d41_gdpr.webp": "6af9",
	"./6523e4f786080394d9e3d297_isae3000-type2.png": "2589",
	"./6523e4f786080394d9e3d297_isae3000-type2.webp": "a7fa",
	"./6523e4f7c9d5096433c50132_iso27001.png": "5253",
	"./6523e4f7c9d5096433c50132_iso27001.webp": "fe81",
	"./CheckSuccess.svg": "cfa9",
	"./End-To-End_Encryption.height-256.png": "c3ab",
	"./MOBILE_Banner_Dados.png": "312e",
	"./MOBILE_Processo_Denuncia.png": "96fc",
	"./MOBILE_Slide1.png": "4327",
	"./MOBILE_Slide2.png": "ff0a",
	"./MOBILE_Slide3.png": "798d",
	"./MOBILE_Slide4.png": "e8e1",
	"./MOBILE_Slide5.png": "14ac",
	"./banner_dados_referentes_denúncias.png": "265a",
	"./banner_info.jpg": "7909",
	"./banner_info.png": "b6fd",
	"./banner_kpis.jpg": "031a",
	"./banner_kpis.png": "e6a0",
	"./banner_teste_2.jpg": "29c8",
	"./canal_denuncias.jpg": "d0fa",
	"./canal_denuncias.png": "8785",
	"./circulo_banner.jpg": "98f7",
	"./circulo_banner.png": "9879",
	"./circulo_banner_center.png": "eb6a",
	"./circulo_banner_edited.jpg": "6c26",
	"./circulo_banner_final.jpg": "7960",
	"./circulo_banner_final.png": "0293",
	"./colaboradores_icone.png": "3197",
	"./encriptacao_ponto_a_ponto.jpg": "1f66",
	"./encriptacao_ponto_a_ponto.png": "fefc",
	"./equipa_suporte.jpg": "86ef",
	"./equipa_suporte.png": "aa09",
	"./favicon_16_16.png": "552d",
	"./favicon_32_32.png": "d467",
	"./habitantes_icone.png": "6dbb",
	"./mockup_ignoto_mac.jpg": "d97a",
	"./mockup_ignoto_mac.png": "5a8a",
	"./processo_denuncia.png": "7675",
	"./slide_2.jpg": "e8e4",
	"./slide_3.jpg": "a20d",
	"./video_processo_denuncia.jpg": "8ba9",
	"./video_processo_denuncia.png": "87f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca96";